import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, getUrlQuery, LL_V_C, LL_VH_C, ModuleFE_RoutingV2, } from '@nu-art/thunderstorm-frontend/index';
import './Page_SmartOnFhir.scss';
import { ModuleFE_AdvisorState, ModuleFE_SmartOnFHIR } from '../../../modules/index.js';
import { QuaiAdvisorPageLoader } from '../../V4/index.js';
import { UserTypesToRouteKeys } from '../../../consts.js';
import { BadImplementationException, LogLevel } from '@nu-art/ts-common';
import { ModuleFE_AdvisorSession } from '../../../_entity/advisor-session/ModuleFE_AdvisorSession.js';
export class Page_SmartOnFhir extends ComponentSync {
    componentDidMount() {
        this.logger.setMinLevel(LogLevel.Verbose);
        this.triggerSmartOnFHIR();
    }
    deriveStateFromProps(nextProps, state) {
        state.triggered ??= false;
        state.readingRecord ??= false;
        return state;
    }
    async triggerSmartOnFHIR() {
        if (this.state.triggered)
            return;
        this.setState({ triggered: true });
        const query = getUrlQuery();
        try {
            const response = await ModuleFE_SmartOnFHIR.launchSmart(query);
            ModuleFE_AdvisorState.setProperties(response.uiState);
            ModuleFE_AdvisorSession.setArtifactMetadata(response.artifactMetadata);
            ModuleFE_AdvisorSession.lastSeenAt = response.lastSeenAt;
            ModuleFE_AdvisorSession.hasRecapItems = !!response.hasRecapItems;
            const routeKey = UserTypesToRouteKeys['physician'];
            const route = ModuleFE_RoutingV2.getRouteByKey(routeKey);
            if (!route) {
                this.logError(`Route doesn't exist for routeKey: ${routeKey}, user-type: ${query['user-type']}`);
                throw new BadImplementationException(`Route doesn't exist for routeKey: ${routeKey}, user-type: ${query['user-type']}`);
            }
            ModuleFE_RoutingV2.goToRoute(route, query);
            setTimeout(() => {
                this.setState({ readingRecord: true });
            }, 5000);
        }
        catch (err) {
            this.logError('Error: ', err);
            this.setState({ err: err });
            return;
        }
    }
    render() {
        if (this.state?.err)
            return _jsx(LL_VH_C, { children: _jsxs(LL_V_C, { children: [_jsx("div", { children: "Error while launching Advisor" }), _jsx("div", { children: this.state.err.debugMessage })] }) });
        if (this.state?.readingRecord)
            return _jsx(QuaiAdvisorPageLoader, { text: 'Reading patient record' });
        return _jsx(QuaiAdvisorPageLoader, { text: 'Launching your Advisor' });
    }
}
//# sourceMappingURL=Page_SmartOnFhir.js.map